import * as React from 'react'

import { MAIN_FAQ } from '@smarty-nx/code-utils'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'

import type { FaqItemProps } from './FaqItem'
import FaqItem from './FaqItem'
import classes from './FaqSection.module.scss'
import { faqSectionContent } from './FaqSection.strings'

interface PaddingProps {
  size?: number
}

interface FaqSectionProps {
  faqAccordions: FaqItemProps[]
  darkText?: boolean
  PaddingComponent?: React.ComponentType<PaddingProps>
}

const DefaultPadding = ({ size }: PaddingProps) => (
  <div style={{ padding: `${(size || 2) * 0.5}rem 0` }} />
)

export const FaqSection = ({
  faqAccordions,
  darkText = false,
  PaddingComponent = DefaultPadding,
}: FaqSectionProps) => {
  const leftAccordions = faqAccordions.slice(
    0,
    Math.ceil(faqAccordions.length / 2)
  )
  const rightAccordions = faqAccordions.slice(
    Math.ceil(faqAccordions.length / 2),
    faqAccordions.length
  )

  return (
    <>
      <h2
        data-testid={faqSectionContent.faqTitleId}
        id="faq"
        className={classes.title}
      >
        {faqSectionContent.faqTitle}
      </h2>
      <section
        data-module-name="faq"
        data-testid="faqs-section"
        className={classes.container}
      >
        <div className={classes.column}>
          {leftAccordions.map((faq) => (
            <FaqItem {...faq} darkText={darkText} key={faq.slug} />
          ))}
        </div>
        <div className={classes.column}>
          {rightAccordions.map((faq) => (
            <FaqItem {...faq} darkText={darkText} key={faq.slug} />
          ))}
        </div>
      </section>
      <>
        <PaddingComponent size={1.75} />
        <a
          href={MAIN_FAQ}
          target="_blank"
          rel="noreferrer noopener"
          data-item-category={TRACKING_CATEGORIES.NAVIGATION}
          data-item-name={faqSectionContent.moreInfoDataItemName}
          data-testid="more-questions-link"
          className={classes.moreInfoLink}
        >
          {faqSectionContent.moreInfoText}
        </a>
      </>
    </>
  )
}

export default FaqSection
